import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { STICKY_PRICE_BAR_BASE_CLASSNAME } from '@vfde-brix/ws10/sticky-price-bar/Constants';
import { createStickyPriceBar } from './StickyPriceBar';
createComponents(".".concat(STICKY_PRICE_BAR_BASE_CLASSNAME), createStickyPriceBar, NO_PATTERN_BUSINESS_LOGIC);
